enum MailType {
    BeforeStart = 'BeforeStart',
    Quotation = 'Quotation',
    ReleaseReminder = 'ReleaseReminder',
    Confirmation = 'Confirmation',
    BookerConfirmation = 'BookerConfirmation',
    Cancellation = 'Cancellation',
    AfterStart = 'AfterStart',
    AfterEnd = 'AfterEnd',
    NotSelected = 'NotSelected',
}

export default MailType;
